module.exports = __webpack_public_path__ + "static/media/date-filter-icon.cd220052.svg";